export default "/images/blue_line__510.png";